<template>
  <div id="insightsManagers2">
    <div class="margin-subpages">
      <el-select v-model="selectTeam" filterable placeholder="Select" class="input-style" @change="handleTeams"
      :class="[ blurMode ?  'blurelement': '' ]">
        <el-option v-if="user.user_type !== 'leadership'" class="text-dropdown" key="all" :label="`All Teams (${$utils(
        'addCommasInNumber',
        optionsTeam.length
      )})`" value="all"></el-option>
        <el-option class="text-dropdown"
        :class="[ blurMode ?  'blurelement': '' ]" 
        v-for="item in optionsTeam" :key="item.key" :label="item.name"
          :value="item.key"></el-option>
      </el-select>
      <div id="activityOverview">
        <div class="mt-32 flex-mid">
          <div class="fs-18 flex-center mr-auto">
            <span class="fw-700 pt-4">{{
        $t("insights.ACTIVITY_OVERVIEW")
      }}</span>
            <span class="span-last-30-day">
              •&nbsp;&nbsp;Last 30 days updated in real-time
            </span>
          </div>
          <img @click="settingsStatus = !settingsStatus" src="../../assets/images/insights/ic_settings@2x.png" alt=""
            class="cursor-pointer" style="height: 32px; width: 32px" />
        </div>

        <div class="report-container mt-14">
          <div>
            <div class="text-header">Manager Activity</div>
            <div class="box-card-border">
              <div class="grid-3-auto">
                <div class="status-box" style="background-color: #66bb6a1a">
                  <div class="title">Responsive</div>
                  <div v-if="loadingManager" class="flex-center mt-8">
                    <div class="image-skeleton opa-08" style="width: 24px; height: 24px; border-radius: 24px">
                      &nbsp;
                    </div>
                    <div class="ml-6">
                      <div class="fs-16 fw-700 text-skeleton" style="width: 30px">
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-8">
                    <img class="circle" :src="$utils('icons', 'User_status_Active_24px')"
                      alt="icons_User_status_Active_24px" />
                    <div class="ml-6">
                      <span class="fs-16 fw-700">{{
        activeOverview.active
      }}</span>
                      <span class="fs-11 fw-700" :class="`text-${activeOverview.compareactive > 0 ? 'green' : 'red'
        }`">
                        {{
        activeOverview.compareactive >= 0
          ? `+${activeOverview.compareactive}`
          : `${activeOverview.compareactive}`
      }}%
                      </span>
                    </div>
                  </div>
                </div>
                <div class="status-box" style="background-color: #fbc02d1a">
                  <div class="title">Moderate</div>
                  <div v-if="loadingManager" class="flex-center mt-8">
                    <div class="image-skeleton opa-08" style="width: 24px; height: 24px; border-radius: 24px">
                      &nbsp;
                    </div>
                    <div class="ml-6">
                      <div class="fs-16 fw-700 text-skeleton" style="width: 30px">
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-8">
                    <img class="circle" :src="$utils('icons', 'User_status_Passive_24px')"
                      alt="icons_User_status_Passive_24px" />
                    <div class="ml-6">
                      <span class="fs-16 fw-700">{{
        activeOverview.passive
      }}</span>
                      <span class="fs-11 fw-700" :class="`text-${activeOverview.comparepassive > 0 ? 'red' : 'green'
        }`">
                        {{
        activeOverview.comparepassive >= 0
          ? `+${activeOverview.comparepassive}`
          : `${activeOverview.comparepassive}`
      }}%
                      </span>
                    </div>
                  </div>
                </div>
                <div class="status-box" style="background-color: #f443361a">
                  <div class="title">Minimal</div>
                  <div v-if="loadingManager" class="flex-center mt-8">
                    <div class="image-skeleton opa-08" style="width: 24px; height: 24px; border-radius: 24px">
                      &nbsp;
                    </div>
                    <div class="ml-6">
                      <div class="fs-16 fw-700 text-skeleton" style="width: 30px">
                        &nbsp;
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-8">
                    <img class="circle" :src="$utils('icons', 'User_status_Inactive_24px@2x')"
                      alt="icons_User_status_Inactive_24px@2x" />
                    <div class="ml-6">
                      <span class="fs-16 fw-700">{{
        activeOverview.inactive
      }}</span>
                      <span class="fs-11 fw-700" :class="`text-${activeOverview.compareinactive > 0 ? 'red' : 'green'
        }`">
                        {{
        activeOverview.compareinactive >= 0
          ? `+${activeOverview.compareinactive}`
          : `${activeOverview.compareinactive}`
      }}%
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="loadingManager" class="fs-12 text-skeleton mt-16" style="width: 120px; background: #6c30cc10">
                &nbsp;
              </div>
              <div v-else class="mt-8">
                <span class="fs-12 opa-06">Managers play a central role in linking your objectives to actions and
                  results.</span>
                <span class="flex-center router-link mt-4" @click="anchorTableLink">
                  <span>Manager Activity Details</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>
              <!-- <div class="line-break mt-12"></div> -->
              <!-- <div class="grid-2-50 mt-20">
                <div class="mr-6">
                  <div class="flex-center">
                    <div class="title">Proactivity Rating</div>
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          A measure of how well managers control a situation by
                          causing something to happen rather than responding to
                          it after it has happened.
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                        alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                  <div v-if="loadingManagerInsight" class="flex-center opa-06 mt-6">
                    <div class="score-box flex-mid"></div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar opa-04">
                        <div class="value"></div>
                      </div>
                      <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-6">
                    <div class="score-box flex-mid" :class="`${insight.proactivityRatingValue >
                      benchmarkProactivityRatingScore
                      ? 'green'
                      : insight.proactivityRatingValue < 40
                        ? 'red'
                        : 'yellow'
                      }`">
                      {{ insight.proactivityRatingValue }}
                    </div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar">
                        <div class="value" :style="`width: ${benchmarkBar(
                          insight.proactivityRatingValue
                        )}px; ${insight.proactivityRatingValue >=
                          benchmarkProactivityRatingScore
                          ? ''
                          : insight.proactivityRatingValue < 40
                            ? ' background-color: #F44336;'
                            : ' background-color: #FBC02D;'
                          }`"></div>
                        <div class="value benchmark" :style="`width: ${benchmarkBar(
                          benchmarkProactivityRatingScore
                        )}px;`"></div>
                      </div>
                      <div class="flex-center fs-10 fw-700 mt-2 opa-04">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="loadingManager" class="fs-12 mt-4">
                    <div class="text-skeleton opa-04" style="width: 80px">
                      &nbsp;
                    </div>
                  </div>
                  <div v-else class="fs-12 mt-4">
                    <div class="fw-900 text-green" v-if="insight.proactivityRatingValue ==
                      benchmarkProactivityRatingScore
                      ">
                      {{
                        insight.proactivityRatingValue -
                        benchmarkProactivityRatingScore
                      }}
                      {{ $t("insights.points") }}
                      <span class="fc-000000 fw-400">
                        {{ $t("insights.above_benchmark") }} ({{
                          benchmarkProactivityRatingScore
                        }})</span>
                    </div>
                    <div v-else>
                      <span class="fw-900 text-green" v-if="insight.proactivityRatingValue >
                          benchmarkProactivityRatingScore
                          ">{{
      insight.proactivityRatingValue -
      benchmarkProactivityRatingScore
    }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
                          benchmarkProactivityRatingScore }})</span>
                      </span>
                      <span v-else class="fw-900 text-red">{{
                        (insight.proactivityRatingValue -
                          benchmarkProactivityRatingScore) *
                        -1
                      }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
                          benchmarkProactivityRatingScore }})</span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="ml-6">
                  <div class="flex-center">
                    <div class="title">Psychological Safety Rating</div>
                    <el-tooltip class="header-table-tooltip" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          A measure of being able to express oneself without
                          fear of negative consequences or a shared belief that
                          the team is safe for interpersonal risk taking.
                        </div>
                      </div>
                      <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                        alt="icons_ic_help_outline-16px" />
                    </el-tooltip>
                  </div>
                  <div v-if="loadingManagerOverview" class="flex-center opa-06 mt-6">
                    <div class="score-box flex-mid"></div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar opa-04">
                        <div class="value"></div>
                      </div>
                      <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex-center mt-6">
                    <div class="score-box flex-mid" :class="`${_activeOverview.psychologicalRatingValue >
                      benchmarkPsychologicalRatingScore
                      ? 'green'
                      : _activeOverview.psychologicalRatingValue < 50
                        ? 'red'
                        : 'yellow'
                      }`">
                      {{ _activeOverview.psychologicalRatingValue }}
                    </div>
                    <div class="mt-12" style="width: 120px">
                      <div class="point-bar">
                        <div class="value" :style="`width: ${benchmarkBar(
                          _activeOverview.psychologicalRatingValue
                        )}px; ${_activeOverview.psychologicalRatingValue >
                          benchmarkPsychologicalRatingScore
                          ? ''
                          : _activeOverview.psychologicalRatingValue < 50
                            ? ' background-color: #F44336;'
                            : ' background-color: #FBC02D;'
                          }`"></div>
                        <div class="value benchmark" :style="`width: ${benchmarkBar(
                          benchmarkPsychologicalRatingScore
                        )}px;`"></div>
                      </div>
                      <div class="flex-center opa-04 fs-10 fw-700 mt-2 opa-04'">
                        <div>0</div>
                        &nbsp;
                        <div class="ml-auto">100</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="loadingManagerOverview" class="fs-12 mt-4">
                    <div class="text-skeleton opa-04" style="width: 80px">
                      &nbsp;
                    </div>
                  </div>
                  <div v-else class="fs-12 mt-4">
                    <div v-if="_activeOverview.psychologicalRatingValue ==
                      benchmarkPsychologicalRatingScore
                      ">
                      <span class="fc-000000 fw-400">
                        {{ $t("insights.point_same_benchmark") }} ({{
                          benchmarkPsychologicalRatingScore
                        }})</span>
                    </div>
                    <div v-else>
                      <span class="fw-900 text-green" v-if="_activeOverview.psychologicalRatingValue >
                          benchmarkPsychologicalRatingScore
                          ">{{
      _activeOverview.psychologicalRatingValue -
      benchmarkPsychologicalRatingScore
    }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
                          benchmarkPsychologicalRatingScore }})</span>
                      </span>
                      <span v-else class="fw-900 text-red">{{
                        (_activeOverview.psychologicalRatingValue -
                          benchmarkPsychologicalRatingScore) *
                        -1
                      }}
                        {{ $t("insights.points") }}

                        <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
                          benchmarkPsychologicalRatingScore }})</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="ml-16">
            <div class="text-header">Manager Activity</div>
            <div class="box-card-border">
              <div class="fs-12">

                <div class="grid-2-50 " style="grid-template-columns: 56% 48%">
                  <div>
                    <div class="title">
                      {{ "Feedback Rate" }}
                    </div>
                    <div class="mt-8">
                      <div v-if="loadingManagerOverview" class="flex-center">
                        <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                          &nbsp;
                        </div>
                        <div class="text-skeleton ml-6" style="width: 40px">
                          &nbsp;
                        </div>
                      </div>
                      <div v-else class="flex-center mt-6">
                        <img :src="$utils('icons', 'Open-ended_fb_rate-blue-32x32')"
                          alt="icons_Open-ended_fb_rate-blue-32x32" style="width: 32px" />
                        <div class="fs-16 fw-700 ml-6">
                          {{
        `${_activeOverview.openEndedFeedback.openEndedFeedback}%`
      }}
                        </div>
                        <div v-if="_activeOverview.openEndedFeedback.compare != 0" :class="`label-change ${_activeOverview.openEndedFeedback.compare > 0
        ? 'text-green'
        : 'text-red'
        }`">
                          {{
        _activeOverview.openEndedFeedback.compare > 0
          ? `+${_activeOverview.openEndedFeedback.compare}`
          : `${_activeOverview.openEndedFeedback.compare}`
      }}
                          pts
                        </div>
                        <div v-else :class="`label-change fc-6A6A6A`">
                          +{{ _activeOverview.openEndedFeedback.compare }} pts
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="title">Reply Rate</div>
                    <div v-if="loadingManagerOverview" class="flex-center mt-6">
                      <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                        &nbsp;
                      </div>
                      <div class="text-skeleton opa-08 ml-6" style="width: 40px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <img class="gray-icon-32" :src="$utils('icons', 'Reply_rate-blue-32x32')"
                        alt="icons_Reply_rate-blue-32x32" />
                      <div class="fs-16 fw-700 ml-6">
                        {{ insight["insight"].feedback.thirty }}%
                      </div>
                      <div :class="`label-change ${insight.insight.feedback.compare >= 0 ? 'text-green' : 'text-red'
        }`">
                        {{
        insight["insight"].feedback.compare >= 0
          ? `+${insight["insight"].feedback.compare}`
          : `${insight["insight"].feedback.compare}`
      }}
                        pts
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 
                <div class="grid-2-50 mt-16" style="grid-template-columns: 56% 48%">
                  <div>
                    <div class="title">Response (days)</div>
                    <div v-if="loadingresponse" class="flex-center mt-6">
                      <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                        &nbsp;
                      </div>
                      <div class="text-skeleton opa-08 ml-6" style="width: 40px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <img class="gray-icon-32" :src="$utils('icons', 'ic_response_time')" alt="ic_response_time" />
                      <div class="fs-16 fw-700 ml-6">
                        {{ insightresponse.response }}
                      </div>
                      <div :class="`label-change ${insightresponse.compare >= 0 ? 'text-red' : 'text-green'
                        }`">
                        {{
                          insightresponse.compare >= 0
                          ? `+${insightresponse.compare}`
                          : `${insightresponse.compare}`
                        }}

                      </div>
                      <div v-else :class="`label-change fc-6A6A6A`">
                        {{ `+${activeOverview["insight"].feedback.compare}` }}
                        pts
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="title">Reply Quality</div>
                    <div v-if="loadingManagerOverview" class="flex-center mt-6">
                      <div class="image-skeleton opa-08" style="width: 32px; height: 32px; border-radius: 32px">
                        &nbsp;
                      </div>
                      <div class="text-skeleton opa-08 ml-6" style="width: 40px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <img class="gray-icon-32" :src="$utils('icons', 'Reply_quality-blue-32x32')"
                        alt="icons_Reply_quality-blue-32x32" />
                      <div class="fs-16 fw-700 ml-6">
                        {{ _activeOverview["replyQuality"].replyQuality }}
                      </div>
                      <div v-if="_activeOverview['replyQuality'].compare != 0" :class="`label-change ${_activeOverview['replyQuality'].compare > 0
                        ? 'text-green'
                        : 'text-red'
                        }`">
                        {{
                          _activeOverview["replyQuality"].compare > 0
                          ? `+${_activeOverview["replyQuality"].compare}`
                          : `${_activeOverview["replyQuality"].compare}`
                        }}%
                      </div>
                      <div v-else :class="`label-change fc-6A6A6A`">
                        {{ `+${_activeOverview["replyQuality"].compare}` }}%
                      </div>
                    </div>
                  </div>
                </div> -->
                <div class="line-break mt-12"></div>

                <div v-if="loadingManagerInsight" class="fs-12 text-skeleton mt-16"
                  style="width: 110px; background: #6c30cc10">
                  &nbsp;
                </div>
                <div v-else class="mt-14">
                  <span class="flex-center router-link mt-4" @click="routerLink('power-ups', 'performance')">
                    <span>Performance Boosts On Track</span>
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
                <div>
                  <div v-if="loadingManagerInsight" class="flex-center mt-6">
                    <div class="image-skeleton opa-04" style="width: 32px; height: 32px; border-radius: 32px">
                      &nbsp;
                    </div>
                    <div class="text-skeleton opa-06 ml-6" style="width: 40px">
                      &nbsp;
                    </div>
                  </div>
                  <div v-else class="flex-center mt-6">
                    <img class="gray-icon-32" :src="$utils('icons', 'Top_performer-blue-32x32')"
                      alt="icons_Top_performer-blue-32x32" />
                    <div class="fs-16 fw-700 ml-6">
                      <!-- {{
        insight.insight
          .review
      }}% -->{{getReviewCompleted()}}%
                    </div>
                    <!-- <div v-if="insight.performerRecognition
                          .compareTopPerformerRecognition != 0
                        " :class="`label-change ${insight.performerRecognition
      .compareTopPerformerRecognition > 0
      ? 'text-green'
      : 'text-red'
      }`">
                      {{
                        insight.performerRecognition
                          .compareTopPerformerRecognition > 0
                        ? `+${insight.performerRecognition.compareTopPerformerRecognition}`
                        : `${insight.performerRecognition.compareTopPerformerRecognition}`
                      }}
                      pts
                    </div>
                    <div v-else-if="!loadingManagerInsight" :class="`label-change fc-6A6A6A`">
                      +{{
                        insight.performerRecognition
                          .compareTopPerformerRecognition
                      }}
                      pts
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ml-16">
            <div class="text-header">Insights & Nudges</div>
            <div class="box-card-border fs-12">
              <div class="title">Daily Insights</div>
              <div class="mt-6">
                <div v-if="loadingManagerInsight" class="bar-contariner flex-center opa-06">
                  <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="bar-contariner flex-center">
                  <div v-for="(value, index) in arrayToPercentage(
        insight['insight'].report_daily_boss.thirty
      )" :key="index + '_bar_adoption'" :class="`bar ${value}`"></div>
                  <div class="fs-16 fw-700 ml-6">
                    {{ insight["insight"].report_daily_boss.thirty }}%
                  </div>
                  <div v-if="insight['insight'].report_daily_boss.compare != 0
        " :class="`label-change ${0 > insight['insight'].report_daily_boss.compare
        ? 'text-red'
        : 'text-green'
        }`">
                    {{
        insight["insight"].report_daily_boss.compare
          ? insight["insight"].report_daily_boss.compare >
            0
            ? `+${insight["insight"].report_daily_boss.compare}`
            : insight["insight"].report_daily_boss.compare
          : 0
      }}%
                  </div>

                  <div v-else class="label-change fc-6A6A6A">
                    +{{ dailyInsightsChange }}%
                  </div>
                </div>
              </div>
              <div class="title mt-16">Weekly Insights</div>
              <div class="mt-6">
                <div v-if="loadingManagerInsight" class="bar-contariner flex-center opa-06">
                  <div v-for="(value, index) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="index + '_bar_mock_one'"
                    :class="`bar ${value}`"></div>
                  <div class="text-skeleton ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="bar-contariner flex-center mb-13">
                  <div v-for="(value, index) in arrayToPercentage(
        insight.insight.report_weekly_boss.thirty
      )" :key="index + '_bar_adoption'" :class="`bar ${value}`"></div>
                  <div class="fs-16 fw-700 ml-6">
                    {{ insight["insight"].report_weekly_boss.thirty }}%
                  </div>
                  <div v-if="weeklyInsightsChange != 0" :class="`label-change ${0 > insight['insight'].report_weekly_boss.compare
        ? 'text-red'
        : 'text-green'
        }`">
                    {{
        insight["insight"].report_weekly_boss.compare
          ? insight["insight"].report_weekly_boss.compare >
            0
            ? `+${insight["insight"].report_weekly_boss.compare}`
            : insight["insight"].report_weekly_boss.compare
          : 0
      }}%
                  </div>

                  <div v-else :class="`label-change fc-6A6A6A`">
                    +{{ weeklyInsightsChange }}%
                  </div>
                </div>
              </div>
              <!-- <div class="line-break mt-14"></div> -->
              <!-- <div v-if="loadingManagerNudges" class="fs-12 text-skeleton mt-16"
                style="width: 40px; background: #6c30cc10">
                &nbsp;
              </div>
              <div v-else class="mt-14">
                <span class="flex-center router-link mt-4" @click="routerLink('sparks', 'nudges')">
                  <span>Nudges</span>
                  <i class="el-icon-arrow-right"></i>
                </span>
              </div>

              <div>
                <div v-if="loadingManagerNudges" class="flex-center mt-6">
                  <div class="image-skeleton opa-04" style="width: 32px; height: 32px; border-radius: 32px">
                    &nbsp;
                  </div>
                  <div class="text-skeleton opa-06 ml-6" style="width: 40px">
                    &nbsp;
                  </div>
                </div>
                <div v-else class="flex-center mt-6">
                  <img class="gray-icon-32" :src="$utils('icons', 'nudges-blue-32x32')" alt="icons_nudges-blue-32x32" />
                  <div class="fs-16 fw-700 ml-6">
                    {{ this.$utils("addCommasInNumber", nudges) }}
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="report-container mt-14">
          <div class="box-card-border" style="width: 868px">
            <div class="flex-row" style="align-items: center;">
              <div class="progress-wrapper ml-24" style="width: 200px">
                <div class="progress-wrapper">
                  <svg width="135" height="135" viewBox="0 0 26 26">
                    <circle cx="13" cy="13" r="12" fill="none" stroke-width="2" stroke="#E0E0E0"></circle>
                    <circle
                      v-if="_activeOverview && _activeOverview.replyQuality && _activeOverview.replyQuality.replyQuality > 0"
                      cx="13" cy="13" r="12" fill="none" :stroke-width="2"
                      :stroke="getStrokeColor(_activeOverview.replyQuality.replyQuality)" :stroke-dasharray="75.4"
                      :stroke-dashoffset="75.4 - (_activeOverview.replyQuality.replyQuality * 0.754)"
                      transform="rotate(-90 13 13)">
                    </circle>
                  </svg>
                  <div v-if="loadingManagerOverview" class="score-label">
                    <!-- <div class="fw-700 main">Loading...</div> -->
                    <div class="text-skeleton main opa-08" style="width: 52px">
                      &nbsp;
                    </div>
                    <div class="fs-16 fw-500 description">Quality</div>
                  </div>
                  <div v-else class="score-label">
                    <div class="fw-700 main">{{ _activeOverview["replyQuality"] ?
        _activeOverview["replyQuality"].replyQuality : 0 }}</div>
                    <div class="fs-16 fw-500 description">Quality</div>
                  </div>
                </div>


              </div>
              <div style="width: 398px">
                <div style="width: 322px">
                  <canvas ref="QualityChart"></canvas>
                </div>
              </div>
              <div style="width: 245px">
                <div>
                  <div class="mr-6">
                    <div class="flex-center">
                      <div class="title">Proactivity Rating</div>
                      <el-tooltip class="header-table-tooltip" placement="top">
                        <div slot="content" class="p-5">
                          <div style="max-width: 250px">
                            A measure of how well managers control a situation by
                            causing something to happen rather than responding to
                            it after it has happened.
                          </div>
                        </div>
                        <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                          alt="icons_ic_help_outline-16px" />
                      </el-tooltip>
                    </div>
                    <div v-if="loadingManagerInsight" class="flex-center opa-06 mt-6">
                      <div class="score-box flex-mid"></div>
                      <div style="width: 120px">
                        <div class="point-bar opa-04">
                          <div class="value"></div>
                        </div>
                        <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <div class="score-box flex-mid" :class="`${insight.proactivityRatingValue >
        benchmarkProactivityRatingScore
        ? 'green'
        : insight.proactivityRatingValue < 40
          ? 'red'
          : 'yellow'
        }`">
                        {{ insight.proactivityRatingValue }}
                      </div>
                      <div class="mt-12" style="width: 120px">
                        <div class="point-bar">
                          <div class="value" :style="`width: ${benchmarkBar(
        insight.proactivityRatingValue
      )}px; ${insight.proactivityRatingValue >=
        benchmarkProactivityRatingScore
        ? ''
        : insight.proactivityRatingValue < 40
          ? ' background-color: #F44336;'
          : ' background-color: #FBC02D;'
        }`"></div>
                          <div class="value benchmark" :style="`width: ${benchmarkBar(
        benchmarkProactivityRatingScore
      )}px;`"></div>
                        </div>
                        <div class="flex-center fs-10 fw-700 mt-2 opa-04">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="loadingManager" class="fs-12 mt-4">
                      <div class="text-skeleton opa-04" style="width: 80px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="fs-12 mt-4">
                      <div class="fw-900 text-green" v-if="insight.proactivityRatingValue ==
        benchmarkProactivityRatingScore
        ">
                        {{
        insight.proactivityRatingValue -
        benchmarkProactivityRatingScore
      }}
                        {{ $t("insights.points") }}
                        <span class="fc-000000 fw-400">
                          {{ $t("insights.above_benchmark") }} ({{
        benchmarkProactivityRatingScore
      }})</span>
                      </div>
                      <div v-else>
                        <span class="fw-900 text-green" v-if="insight.proactivityRatingValue >
        benchmarkProactivityRatingScore
        ">{{
        insight.proactivityRatingValue -
        benchmarkProactivityRatingScore
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
        benchmarkProactivityRatingScore }})</span>
                        </span>
                        <span v-else class="fw-900 text-red">{{
        (insight.proactivityRatingValue -
          benchmarkProactivityRatingScore) *
        -1
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
        benchmarkProactivityRatingScore }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="flex-center mt-13">
                      <div class="title">Psychological Safety Rating</div>
                      <el-tooltip class="header-table-tooltip" placement="top">
                        <div slot="content" class="p-5">
                          <div style="max-width: 250px">
                            A measure of being able to express oneself without
                            fear of negative consequences or a shared belief that
                            the team is safe for interpersonal risk taking.
                          </div>
                        </div>
                        <img :src="$utils('icons', 'ic_help_outline-16px')" class="ml-6 cursor-pointer"
                          alt="icons_ic_help_outline-16px" />
                      </el-tooltip>
                    </div>
                    <div v-if="loadingManagerOverview" class="flex-center opa-06 mt-6">
                      <div class="score-box flex-mid"></div>
                      <div class="mt-12" style="width: 120px">
                        <div class="point-bar opa-04">
                          <div class="value"></div>
                        </div>
                        <div class="flex-center fs-10 fw-700 mt-2 opa-01">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-else class="flex-center mt-6">
                      <div class="score-box flex-mid" :class="`${_activeOverview.psychologicalRatingValue >
        benchmarkPsychologicalRatingScore
        ? 'green'
        : _activeOverview.psychologicalRatingValue < 50
          ? 'red'
          : 'yellow'
        }`">
                        {{ _activeOverview.psychologicalRatingValue }}
                      </div>
                      <div class="mt-12" style="width: 120px">
                        <div class="point-bar">
                          <div class="value" :style="`width: ${benchmarkBar(
        _activeOverview.psychologicalRatingValue
      )}px; ${_activeOverview.psychologicalRatingValue >
        benchmarkPsychologicalRatingScore
        ? ''
        : _activeOverview.psychologicalRatingValue < 50
          ? ' background-color: #F44336;'
          : ' background-color: #FBC02D;'
        }`"></div>
                          <div class="value benchmark" :style="`width: ${benchmarkBar(
        benchmarkPsychologicalRatingScore
      )}px;`"></div>
                        </div>
                        <div class="flex-center opa-04 fs-10 fw-700 mt-2 opa-04'">
                          <div>0</div>
                          &nbsp;
                          <div class="ml-auto">100</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="loadingManagerOverview" class="fs-12 mt-4">
                      <div class="text-skeleton opa-04" style="width: 80px">
                        &nbsp;
                      </div>
                    </div>
                    <div v-else class="fs-12 mt-4">
                      <div v-if="_activeOverview.psychologicalRatingValue ==
        benchmarkPsychologicalRatingScore
        ">
                        <span class="fc-000000 fw-400">
                          {{ $t("insights.point_same_benchmark") }} ({{
        benchmarkPsychologicalRatingScore
      }})</span>
                      </div>
                      <div v-else>
                        <span class="fw-900 text-green" v-if="_activeOverview.psychologicalRatingValue >
        benchmarkPsychologicalRatingScore
        ">{{
        _activeOverview.psychologicalRatingValue -
        benchmarkPsychologicalRatingScore
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.above_benchmark") }} (<span></span>{{
        benchmarkPsychologicalRatingScore }})</span>
                        </span>
                        <span v-else class="fw-900 text-red">{{
        (_activeOverview.psychologicalRatingValue -
          benchmarkPsychologicalRatingScore) *
        -1
      }}
                          {{ $t("insights.points") }}

                          <span class="fc-000000 fw-400">{{ $t("insights.below_benchmark") }} (<span></span>{{
        benchmarkPsychologicalRatingScore }})</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal-preview-user v-if="modalPreviewDataStatus" :modalMemberData="modalMemberData" :userDetail="userDetail"
        :showingModal="modalPreviewDataStatus" :passProfileToRelationship="passProfileToRelationship"
        @closed="closedModal"></modal-preview-user>
      <div id="byManager">
        <div class="flex-row-between">
          <div>
            <div class="mt-30 fs-18 fw-700">{{ $t("insights.BY_MANAGER") }}</div>
            <div class="fc-747474 fs-13 mt-6">
              {{ $t("insights.Managers_activity_in") }}
            </div>
          </div>
          <div class="flex-center mt-30" id="menuDropdown">

            <el-menu class="el-menu-demo menu-option-style" mode="horizontal" style="height: 40px;">
              <el-submenu index="0" style="width: 220px; height: 40px;">
                <template slot="title">
                  <span class="txtOption1" style="height: 40px;">{{ selectChart }}</span>
                </template>
                <el-menu-item index="1" @click="changeChart('vs Reply Quality')"
                  style="font-size: 14px; width: 220px">vs Reply Quality
                </el-menu-item>
                <el-menu-item index="2" @click="changeChart('vs Open Rate')" style="font-size: 14px; width: 220px">vs
                  Open Rate
                </el-menu-item>

              </el-submenu>
            </el-menu>
          </div>
        </div>

        <div class="flex-mid" style="height: 254px" v-if="loadingManager">
          <loading-even></loading-even>
        </div>
        <div v-else style="height: 0px; width: 0px">
          <div class="fs-11 fw-500 opa-07 site-text">
            {{ selectChart }}
          </div>
        </div>
        <div v-if="!loadingManager" class="chart-container">
          <div class="center">
            <div class="flex-mid">
              <img src="../../assets/images/insights/ic_bubble_size@2x.png" alt="" style="height: 24px; width: 24px" />
              <div class="center fs-11 fw-500 opa-07 ml-4">
                {{ $t("insights.Team_Size") }}
              </div>
            </div>
          </div>
          <div style="height: 190px">
            <canvas ref="managerChart"></canvas>
          </div>
          <div class="center fs-11 fw-500 opa-07">
            {{ $t("insights.Feedback_Reply_Rate") }}
          </div>
        </div>
      </div>
      <div id="scorecard" class="fs-18 fw-700 mt-40">Manager Scorecard</div>
      <div class="fs-13 fc-747474 mt-6">This scorecard provides an overview of the key activities and performance
        metrics for
        managers, focusing on their interactions with direct reports. It helps understand how well managers role model
        key
        behaviors, drive performance, and engage their teams.</div>

      <div ref="table_anchor" id="table" class="mt-24">
        <div class="flex" style="margin-bottom: 10px; margin-right: 10px">
          <div class="mr-auto">
            <el-input class="input-style" style="height: 40px" autosize :placeholder="$t('global.Search')"
              @keyup.native="typeingSearchManager" v-model="inputSearch"></el-input>
          </div>
          <div style="width: 220px; margin-right: 52px" id="menuDropdownType" class="flex">
            <el-menu class="el-menu-demo menu-option-style" mode="horizontal">
              <el-submenu index="0" style="width: 220px">
                <template slot="title">
                  <span class="txtOption" v-if="selectStatus == 'all'">{{ $t("insights.All_Activity_Types") }}
                    {{
        activeOverview && activeOverview.all
          ? "(" + activeOverview.all + ")"
          : ""
      }}</span>
                  <span class="txtOption" v-if="selectStatus == 'active'">{{ "Responsive" }}
                    {{
        activeOverview && activeOverview.active
          ? "(" + activeOverview.active + ")"
          : ""
      }}</span>
                  <span class="txtOption" v-if="selectStatus == 'passive'">{{ "Moderate" }}
                    {{
        activeOverview && activeOverview.passive
          ? "(" + activeOverview.passive + ")"
          : ""
      }}</span>
                  <span class="txtOption" v-if="selectStatus == 'inactive'">{{ "Minimal" }}
                    {{
        activeOverview && activeOverview.inactive
          ? "(" + activeOverview.inactive + ")"
          : ""
      }}</span>
                </template>
                <el-menu-item v-if="selectStatus !== 'all'" index="1" @click="sortBy('all')"
                  style="font-size: 14px; width: 220px">{{ $t("insights.All_Activity_Types") }}
                  {{
        activeOverview && activeOverview.all
          ? "(" + activeOverview.all + ")"
          : ""
      }}</el-menu-item>
                <el-menu-item v-if="selectStatus !== 'active'" index="2" @click="sortBy('active')"
                  style="font-size: 14px; width: 220px">{{ "Responsive" }}
                  {{
        activeOverview && activeOverview.active
          ? "(" + activeOverview.active + ")"
          : ""
      }}</el-menu-item>
                <el-menu-item v-if="selectStatus !== 'passive'" index="3" @click="sortBy('passive')"
                  style="font-size: 14px; width: 220px">{{ "Moderate" }}
                  {{
        activeOverview && activeOverview.passive
          ? "(" + activeOverview.passive + ")"
          : ""
      }}</el-menu-item>
                <el-menu-item v-if="selectStatus !== 'inactive'" index="4" @click="sortBy('inactive')"
                  style="font-size: 14px; width: 220px">{{ "Minimal" }}
                  {{
        activeOverview && activeOverview.inactive
          ? "(" + activeOverview.inactive + ")"
          : ""
      }}</el-menu-item>
              </el-submenu>
            </el-menu>
            <div class="mt-2 ml-20">
              <div>
          <svg
            @click="exportTable()"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            class="icon-export"
          >
            <path
              fill="currentColor"
              d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"
            />
          </svg>
        </div>
            </div>
            <download-progress :active="showSnackbar"></download-progress>
          </div>
        </div>
        <div class="flex ml-3 mt-28">
          <div style="width: 50px"></div>
          <div style="width: 150px"></div>
          <div style="width: 140px" class="top-title">
            <div>{{ "Leadership" }}</div>
          </div>
          <div style="width: 205px" class="top-title">
            <div>{{ "Performance" }}</div>
          </div>
          <div style="width: 330px" class="top-title">
            <div>{{ "Engagement" }}</div>
          </div>
          <!-- <div style="width: 220px" class="top-title">
            <div>{{ "Engagement" }}</div>
          </div> -->
        </div>


        <div class="flex ml-3 mt-28">
          <div class="fs-11 fw-900" style="width:207px">Manager</div>
          <el-tooltip
            content="Percentage of conversations initiated by this manager with their own manager, demonstrating proactive upward communication"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Conv.<br> Initiated</div>
          </el-tooltip>
          <el-tooltip
            content="Number of peer feedback requests this manager has made for themselves, showing commitment to self-improvement"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Peer <br> Feedback</div>
          </el-tooltip>
          <el-tooltip content="Percentage of performance boosts that are either completed or pending but not overdue"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 ml-24 cursor-pointer" style="text-align: center;width:64px">Boosts <br> On Track
            </div>
          </el-tooltip>
          <el-tooltip content="Overall progress made by direct reports as evaluated in their performance reviews"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Goals <br> Progress</div>
          </el-tooltip>
          <el-tooltip
            content="How well direct reports are contributing to the culture, as evaluated in their performance reviews"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Culture <br> Contr.</div>
          </el-tooltip>
          <el-tooltip content="Percentage of team feedback the manager has responded to in the past 30 days"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 ml-16 cursor-pointer" style="text-align: center;width:82px">Reply <br> Rate</div>
          </el-tooltip>
          <el-tooltip
            content="Percentage of Manager Insights opened from email inbox. Note: May be inaccurate if email tracking is blocked"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">Insights <br> Opened</div>
          </el-tooltip>
          <el-tooltip
            content="Dynamic Engagement Behavior Index of the manager's direct reports, indicating the manager's effectiveness in keeping their team engaged"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer" style="text-align: center;width:64px">DEBI <br> Score</div>
          </el-tooltip>
          <el-tooltip content="Areas of challenge reported by the team that require the manager's attention"
            placement="top" effect="dark">
            <div class="fs-11 fw-900 cursor-pointer">Action Items</div>
          </el-tooltip>
        </div>

        <div v-if="loadingManager && loadingresponse && loadingManagerOverview" class='flex-mid mt-20'>
          <loading-even></loading-even>
        </div>
        <div v-else>
          <!-- new card -->
          <div v-for="(val, index) in datalist" :key="index + 'card'">
            <div class="box-card-table">
              <div class="flex-column ml-12" style=" justify-content: center;min-height: 53px;width:195px;">


                <div>
                  <div class="flex-center cursor-pointer" @click="showPreviewData(val)">
                    <div v-if="val.profilepic" style="width: 36px" class="profilepic"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <img v-lazy="val.profilepic" :key="val.profilepic" class="imgProfile image-skeleton" />
                      <div class="fs-10 fw-600 noti-count">{{ val.directMember }}</div>
                    </div>
                    <div v-else class="profilepic image image-profile-36"
                    :class="[ blurMode ?  'blurelement': '' ]">
                      <span class="text-in-image text-in-image-36 flex-mid" style="width: 36px">{{
        val.shortname
      }}</span>
                      <div class="fs-10 fw-600 noti-count">{{ val.directMember }}</div>
                    </div>
                    <div class="flex-column ml-12">
                      <span style="color: #000" class="txtName ellipsis fs-14 fw-700"
                      :class="[ blurMode ?  'blurelement': '' ]">
                        {{ val.fullname }}
                      </span>
                      <span class="txtTeam ellipsis fs-13 fw-500 opa-06" style=" color: #000"
                      :class="[ blurMode ?  'blurelement': '' ]">{{
        val.team_name }}</span>
                    </div>
                  </div>

                </div>


              </div>


              <!--Leadership-->
              <div class="flex" style="justify-content: center;width:64px">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Conversations', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].conversations_initiated ? dataQualitybyTeam[val.email].conversations_initiated : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].conversations_initiated ? dataQualitybyTeam[val.email].conversations_initiated : 0 }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Peer-Feedback', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].peerfeedback ? dataQualitybyTeam[val.email].peerfeedback : 0))}`">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].peerfeedback ? dataQualitybyTeam[val.email].peerfeedback : 0 }}
                </div>
                <div class="section-break ml-24"></div>
              </div>



              <!--Pergormance-->
              <div class="flex" style="justify-content: center;width:64px;">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Reviews-completed', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.reviewCompleted : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.reviewCompleted : 0 }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;width:64px">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Goals-Progress', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.GoalsProgress : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.GoalsProgress : 0 }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('Culture-Contribution', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.cultuerAdd : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].performance_review ? dataQualitybyTeam[val.email].performance_review.cultuerAdd : 0 }}%
                </div>
                <div class="section-break ml-24"></div>
              </div>

              <!--Engagement-->

              <div class="flex" style="justify-content: center;">
                <el-tooltip effect="light" placement="top">
                  <div slot="content" class="p-5">
                    <div class="flex-column">
                      <div class="flex-mid" style="min-width: 118px">
                        <div class="fs-11" style="width: 50px">Quality</div>
                        <div class="fs-11" style="width: 50px">Time</div>
                      </div>
                      <div class="flex-mid mt-6" style="min-width: 118px">
                        <div class="fs-11 fw-600" style="width: 50px">{{
        val.feedback == '-' ? '-' : val.feedback_check == 'N' && val.feedback == 0 ? '-' : getReplyQuality(val.email)
      }} /
                          100</div>
                        <div class="fs-11 fw-600" style="width: 50px">{{ val.feedback == '-' ? '-' :
        response[val.email] ? response[val.email].response_day > 0 ?
          (`${response[val.email].response_day} days`) : '< 1 hr' : '< 1 hr' }} </div>
                        </div>


                      </div>

                    </div>
                    <div :class="`fs-11 fw-600 box ${getBoxstyle('Reply-Rate', val.feedback)}`"
                      style="width:62px; cursor: pointer;">
                      <img class="circle" style="width:16px;height:16px;margin-right:6px;"
                        :src="getBoxstyle('Reply-Rate', val.feedback) === 'box-red' ? $utils('icons', 'User_status_Inactive_24px') : getBoxstyle('Reply-Rate', val.feedback) === 'box-yellow' ? $utils('icons', 'User_status_Passive_24px') : $utils('icons', 'User_status_Active_24px')"
                        alt="icons_User_status_Active_24px" />
                      {{ val.feedback }}%
                    </div>


                </el-tooltip>

              </div>
              <div class="flex" style="justify-content: center;width:64px">
                <div :class="`fs-11 fw-600 box ${getBoxstyle('Opened', val.overall_rate)}`" style="">{{ val.overall_rate
                  }}%
                </div>
              </div>
              <div class="flex" style="justify-content: center;width:64px">
                <div
                  :class="`fs-11 fw-600 box ${getBoxstyle('DEBI', (dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].DEBI ? dataQualitybyTeam[val.email].DEBI : 0))}`"
                  style="">
                  {{ dataQualitybyTeam[val.email] && dataQualitybyTeam[val.email].DEBI ? dataQualitybyTeam[val.email].DEBI : 0 }}
                </div>
              </div>
              <div class="flex" style="width:90px;margin-right:5px;margin-left:16px;">
                <div v-if="val.critical_area">
                  <span v-for="(item, index) in formattedCriticalAreas(val.critical_area)" :key="index" class="mr-2">
                    <el-tooltip effect="dark" placement="top">
                      <div slot="content" class="p-5">
                        <div style="max-width: 250px">
                          {{ getActionItemTooltip(item) }}
                        </div>
                      </div>
                      <span class="fs-11 cursor-pointer">
                        {{ item }}<span v-if="index < formattedCriticalAreas(val.critical_area).length - 1">,</span>
                      </span>
                    </el-tooltip>
                  </span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="flex-center pagination mt-10">
          <el-pagination @current-change="handleCurrentManagerChange" :current-page="1" :page-size="10" :pager-count="5"
            layout="prev, pager, next" :total="managerResults"></el-pagination>
          <span class="results-status">
            {{ datalist.length > 10 ? 10 : datalist.length }}
            {{ $t("insights.results_from") }}
            {{ $utils("addCommasInNumber", managerResults) }}
            {{ $t("insights.results") }}
          </span>
        </div>

      </div>
    </div>
    <div id="coachingModalStatus">
      <el-dialog :visible.sync="coachingModalStatus" width="600px" top="8vh" title="Manager Coaching Interactions">
        <div class="profile">
          <div class="fc-000000 fs-18 fw-700">
            {{
        modalCoachingData && modalCoachingData["user"]
          ? modalCoachingData["user"].firstname +
          " " +
          modalCoachingData["user"].lastname
          : ""
      }}
          </div>
          <div class="fc-626262 fs-14">
            {{
          modalCoachingData && modalCoachingData["user"]
            ? modalCoachingData["user"].team_name
            : ""
        }}
          </div>
        </div>
        <div class="table">
          <el-table :data="modalCoachingData['coaching']"
            :empty-text="loadingCoaching ? ' ' : 'No coaching interactions'" max-height="490" style="width: 100%"
            id="dataTable" class="el-table-thin-scrollbar">
            <el-table-column :label="$t('insights.Date')" width="150">
              <template slot-scope="scope">
                <span class="text-modal">
                  {{ scope.row.date }}
                </span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('insights.Challenge')" width="180">
              <template slot-scope="scope">
                <span class="text-modal fw-700">{{
        scope.row.challenges
      }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('insights.Score')" width="80" prop="score" sortable header-align="center"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.score >= 0" class="text-modal flex score">
                  <div class="circle-score circle-red" :class="{
        'circle-green': scope.row.score >= scope.row.standard[0],
        'circle-yellow':
          scope.row.score < scope.row.standard[0] &&
          scope.row.score >= scope.row.standard[1],
        'circle-red': scope.row.score,
      }"></div>
                  {{ scope.row.score }}%
                </div>
                <span v-else class="text-modal">-%</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('insights.Status')" width="120" sortable prop="status" header-align="center"
              align="right">
              <template slot-scope="scope">
                <span class="text-modal">{{ scope.row.status }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex-mid" style="height: 254px" v-if="loadingCoaching">
            <loading-even></loading-even>
          </div>
        </div>
      </el-dialog>
    </div>
    <div id="managerClassificationSettingsModalStatus">
      <el-dialog :visible.sync="settingsStatus" :before-close="beforeCloseSettingsModal" width="720px" top="8vh"
        title="Manager Classification Settings">
        <div class="body">
          <div class="active">
            <div class="fs-18 fw-700 fc-000000">
              {{ $t("insights.ACTIVE") }}
            </div>
            <div class="flex">
              <div>
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Insights_Open_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changeActiveInsightsOpen" v-model="managerClassificationSettings.insightsOpen.active
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.max"
                      :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
              <div class="ml-40">
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Feedback_Reply_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changeActiveFeedbackReply" v-model="managerClassificationSettings.feedbackReply.active
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply.max"
                      :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="passive mt-32">
            <div class="fs-18 fw-700 fc-000000">
              {{ $t("insights.PASSIVE") }}
            </div>
            <div class="flex">
              <div>
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Insights_Open_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changePassiveInsightsOpen" v-model="managerClassificationSettings.insightsOpen.passive
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.passiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
              <div class="ml-40">
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Feedback_Reply_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" @input.native="changePassiveFeedbackRepl" v-model="managerClassificationSettings.feedbackReply.passive
        "></el-input>
                    <div class="percentag-text">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply.passiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inactive mt-32">
            <div class="fs-18 fw-700 fc-000000">
              {{ $t("insights.INACTIVE") }}
            </div>
            <div class="flex">
              <div>
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Insights_Open_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.inactive
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.insightsOpen.inactiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
              <div class="ml-40">
                <p class="fs-14 fc-000000">
                  {{ $t("insights.Feedback_Reply_Rate") }}
                </p>
                <div class="flex-mid">
                  <div class="title-text-input">{{ $t("insights.Lower") }}</div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply.inactive
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                  <div class="title-text-input ml-16">
                    {{ $t("insights.Upper") }}
                  </div>
                  <div class="input-size">
                    <el-input placeholder="" v-model="managerClassificationSettings.feedbackReply
        .inactiveUpper
        " :disabled="true"></el-input>
                    <div class="percentag-text disabled">%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-reverse" style="margin-top: 72px">
            <el-button @click="setManagerClassificationSettings" style="
                background-color: #32c2d5;
                color: #fff;
                border-radius: 3px;
                width: 100px;
                height: 50px;
              ">{{ $t("insights.SAVE") }}</el-button>
            <el-button style="
                background-color: #d1d1d1;
                color: #fff;
                border-radius: 3px;
                margin-right: 12px;
                width: 120px;
                height: 50px;
              " @click="beforeCloseSettingsModal">{{ $t("insights.CANCEL") }}</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import imageTooltip from "../../assets/images/insights/ic_direct_reports@2x.png";
import store from "@/store/store";

export default {
  name: "managers",
  components: {
    modalPreviewUser: require("@/components/even/modal/user-preview").default,
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    //console.log("ooo")
    this.$store.dispatch("team/getTeamsOptionsFixed", this.user);
    this.$store.dispatch("insightsManagers/getDataAll");

    // this.$store.dispatch("insightsManagers/getDataOverview");
    // this.$store.dispatch("insightsManagers/getNudges");
    //this.$store.dispatch("insightsManagers/getDataOverview");


    // this.$store.dispatch("insightsManagers/setLastCoaching", this.user);
    // this.$store.dispatch("insightsManagers/getDataAll");
    // this.$store.dispatch("insightsManagers/getdatalistAll");
    // this.$store.dispatch("insightsManagers/getManagerClassificationSettings");
  },
  watch: {
    optionsTeam() {
      if (this.optionsTeam.length > 0) {
        this.selectTeam =
          this.user.user_type == "leadership" ? this.user.team : "all";
      }
    },
    insightsOpenPassiveSetting() {
      this.setValueManagerClassificationSettings();
    },
    datalistSearchAll() {
      if (this.myChart) this.myChart.destroy()
      this.createChart();
    },

    // Redundant
    /*
    loadingManager(value) {
      console.log(`watch: loadingManager(${value ? "true" : "false"})`);
      if (value) return;
      setTimeout(() => {
        console.log("watch: loadingManager, setTimeout(300)");
        this.createChart();
        this.createChartQuality();
      }, 300);
    },
    //*/

    selectTeam() {
      this.$store.dispatch("insightsManagers/setTeamSorting", this.selectTeam);
    },
    inputSearch() {
      this.$store.dispatch(
        "insightsManagers/setSearchingText",
        this.inputSearch
      );
    },
    weeklyData() {
      if (this.myChart1) this.myChart1.destroy()
      this.createChartQuality();
    }

  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    optionsTeam() {
      return this.$store.getters["team/teamsfixedall"];
    },
    optionsTeam_Temp() {
      return this.$store.getters["team/teamsfixedall_temp"];
    },
    managerResults() {
      return this.$store.getters["insightsManagers/managerResults"];
    },
    datalist() {
      return this.$store.getters["insightsManagers/datalist"];
    },
    datalistSearchAll() {
      return this.$store.getters["insightsManagers/datalistSearchAll"];
    },
    teamList() {
      return this.$store.getters["insightsManagers/teamList"];
    },
    activeOverview() {
      return this.$store.getters["insightsManagers/activeOverview"];
    },
    loadingManager() {
      return this.$store.getters["insightsManagers/loadingManager"];
    },
    loadingCoaching() {
      return this.$store.getters["insightsManagers/loadingCoaching"];
    },
    insightsOpenPassiveSetting() {
      return this.$store.getters["insightsManagers/getInsightsOpenRateSetting"];
    },
    feedbackReplyPassiveSetting() {
      return this.$store.getters[
        "insightsManagers/getFeedbackReplyRateSetting"
      ];
    },
    showSnackbar() {
      return this.$store.getters["insightsManagers/showSnackbar"];
    },
    modalCoachingData() {
      return this.$store.getters["insightsManagers/modalCoachingData"];
    },

    feedback() {
      return this.$store.getters["dashboard/feedback"];
    },
    loadingManagerOverview() {
      return this.$store.getters["insightsManagers/loadingManagerOverview"];
    },
    _activeOverview() {
      return this.$store.getters["insightsManagers/_activeOverview"];
    },
    loadingManagerNudges() {
      return this.$store.getters["insightsManagers/loadingManagerNudges"];
    },
    nudges() {
      return this.$store.getters["insightsManagers/nudges"];
    },
    insight() {
      return this.$store.getters["insightsManagers/insight"];
    },
    loadingManagerInsight() {
      return this.$store.getters["insightsManagers/loadingManagerInsight"];
    },
    loadingresponse() {
      return this.$store.getters["insightsManagers/loadingresponse"];
    },
    membersall() {
      return this.$store.getters["people/membersall"];
    },
    passProfileToRelationship() {
      let passProfile = {
        firstname: this.userDetail.firstname || "",
        lastname: this.userDetail.lastname || "",
        teamColor: this.userDetail.house_color || "",
        house: this.userDetail.house || "",
        pic: this.userDetail.large_pic || false,
      };
      return passProfile;
    },
    modalMemberData() {
      return this.$store.getters["people/modalMemberData"];
    },
    response() {
      return this.$store.getters["insightsManagers/response"];
    },
    dataQualitybyTeam() {

      return this.$store.getters["insightsManagers/dataQualitybyTeam"];
    },
    insightresponse() {
      return this.$store.getters["insightsManagers/insightresponse"];
    },
    label() {
      return this.$store.getters["insightsManagers/label"];
    },
    weeklyData() {
      return this.$store.getters["insightsManagers/weeklyData"];
    },
    standards_data() {
      return this.$store.getters["insightsManagers/standards_data"];
    },
    formattedCriticalAreas() {
      return (criticalArea) => {
        return criticalArea.split(',').map(item => item.trim());
      };
    },
    memberbyteam(){
      return this.$store.getters["insightsManagers/memberbyteam"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
    user_placeholder(){
      return this.$store.getters["insightsManagers/user_placeholder"];
    },
    teamHeight(){
      return this.$store.getters["insightsManagers/teamHeight"];
    }
  },
  data() {
    return {
      myChart: "",
      myChart1: "",
      selectTeam: "",
      selectStatus: "all",
      inputSearch: "",
      coachingModalStatus: false,
      settingsStatus: false,
      discardedSettingStatus: false,
      managerClassificationSettings: {
        insightsOpen: {
          max: 100,
          active: 60,
          passiveUpper: 59,
          passive: 20,
          inactiveUpper: 19,
          inactive: 0,
        },
        feedbackReply: {
          max: 100,
          active: 40,
          passiveUpper: 39,
          passive: 10,
          inactiveUpper: 9,
          inactive: 0,
        },
      },
      loadingOverview: true,
      //proactivityRatingValue: 34,
      benchmarkProactivityRatingScore: 60,
      psychologicalRatingValue: 82,
      benchmarkPsychologicalRatingScore: 80,
      replyRate: 32,
      replyRateChange: 32,
      replyQuality: 54,
      replyQualityChange: 21,
      // performerRecognition: 52,
      // performerRecognitionChange: 18,
      dailyInsightsPercentage: 87,
      dailyInsightsChange: 7,
      weeklyInsightsPercentage: 65,
      weeklyInsightsChange: 7,
      userDetail: {},
      modalPreviewDataStatus: false,
      selectChart: "vs Open Rate"
    };
  },
  mounted() {
    if (this.optionsTeam.length > 0 && this.selectTeam == "") {
      this.selectTeam =
        this.user.user_type == "leadership" ? this.user.team : "all";
    }
    // this.setValueManagerClassificationSettings();
    //this.createChart();
    setTimeout(() => {
      this.loadingOverview = false;
    }, 2000);
  },
  methods: {
    changeChart(val) {
      this.selectChart = val
      this.$store.dispatch("insightsManagers/getChangeChartType", this.selectChart);
    },
    handleTeams(key) {
      let team = key !== "all" ? this.optionsTeam_Temp[key].key_temp : "";
      this.selectTeam = key;
      this.$store.dispatch("insightsManagers/getDataAll", team);
      //this.$store.dispatch("insightsManagers/getDataOverview", team);
      //this.$store.dispatch("insightsManagers/changeTeam", team);
    },
    handleCurrentManagerChange(val) {

      this.$store.dispatch("insightsManagers/currentManagerChange", val);
    },
    typeingSearchManager() {
      this.$store.dispatch("insightsManagers/searchManager", {
        value: this.inputSearch,
        typingTimeout: this.variable.typingTimeout,
      });
    },
    ManagerSort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("insightsManagers/sortManager", [
          column.property,
          order,
        ]);
      }
    },
    setValueManagerClassificationSettings() {
      let iopsa = this.insightsOpenPassiveSetting.active;
      let iopsp = this.insightsOpenPassiveSetting.passive;
      this.managerClassificationSettings.insightsOpen = {
        max: 100,
        active: iopsa,
        passive: iopsp,
        passiveUpper: iopsa - 1 < 0 ? 0 : iopsa - 1,
        inactiveUpper: iopsp - 1 < 0 ? 0 : iopsp - 1,
        inactive: 0,
      };
      let frpsa = this.feedbackReplyPassiveSetting.active;
      let frpsp = this.feedbackReplyPassiveSetting.passive;
      this.managerClassificationSettings.feedbackReply = {
        max: 100,
        active: frpsa,
        passive: frpsp,
        passiveUpper: frpsa - 1 < 0 ? 0 : frpsa - 1,
        inactiveUpper: frpsp - 1 < 0 ? 0 : frpsp - 1,
        inactive: 0,
      };
    },
    beforeCloseSettingsModal() {
      if (this.discardedSettingStatus) {
        this.setValueManagerClassificationSettings();
        this.$message({
          showClose: true,
          message: "Changes discarded.",
          type: "warning",
        });
      }
      this.settingsStatus = !this.settingsStatus;
    },
    returnStatus(status) {
      if (status == "completed") {
        return "Completed";
      } else if (status == "active") {
        return "Active";
      } else {
        return "Pending";
      }
    },
    checkedLowerAndUpperSetting() {
      let insightStatus = true,
        feedbackReplyStatus = true;

      let insightActiveLower =
        this.managerClassificationSettings.insightsOpen.active;
      let insightPassiveUpper =
        this.managerClassificationSettings.insightsOpen.passive;
      if (parseInt(insightActiveLower) < parseInt(insightPassiveUpper)) {
        setTimeout(() => {
          this.$message({
            showClose: true,
            message: `[ Insights Open Rate ] ACTIVE Rate can not be lower then PASSIVE Rate!`,
            type: "error",
          });
        }, 100);
        insightStatus = false;
      }

      let feedbackActiveLower =
        this.managerClassificationSettings.feedbackReply.active;
      let feedbackPassiveUpper =
        this.managerClassificationSettings.feedbackReply.passive;
      if (parseInt(feedbackActiveLower) < parseInt(feedbackPassiveUpper)) {
        setTimeout(() => {
          this.$message({
            showClose: true,
            message: `[Insights Open Rate] ACTIVE Rate can not be lower then PASSIVE Rate!`,
            type: "error",
          });
        }, 400);
        feedbackReplyStatus = false;
      }
      return insightStatus && feedbackReplyStatus;
    },
    changeActiveInsightsOpen(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.insightsOpen.active = value;
      this.managerClassificationSettings.insightsOpen.passiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    changeActiveFeedbackReply(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.feedbackReply.active = value;
      this.managerClassificationSettings.feedbackReply.passiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    changePassiveInsightsOpen(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.insightsOpen.passive = value;
      this.managerClassificationSettings.insightsOpen.inactiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    changePassiveFeedbackRepl(par) {
      let value = this.returnNumberForInput(par.target.value);
      this.managerClassificationSettings.feedbackReply.passive = value;
      this.managerClassificationSettings.feedbackReply.inactiveUpper =
        value - 1 < 0 ? 0 : value - 1;
    },
    returnNumberForInput(value) {
      this.discardedSettingStatus = true;
      let reg = /\D/g;
      let input = value.replace(reg, "");
      let text = input,
        textLength = input.length;
      if (textLength > 2) {
        text = text.substring(textLength - 2, textLength);
        let status = parseInt(text) > 9;

        if (!status) {
          text = text.substring(textLength - 2, textLength);
        }
        return text;
      } else {
        return text;
      }
    },
    setManagerClassificationSettings() {
      if (this.checkedLowerAndUpperSetting()) {
        this.$store.dispatch(
          "insightsManagers/setManagerClassificationSettings",
          {
            insightActiveLower:
              this.managerClassificationSettings.insightsOpen.active,
            insightPassiveUpper:
              this.managerClassificationSettings.insightsOpen.passive,
            feedbackActiveLower:
              this.managerClassificationSettings.feedbackReply.active,
            feedbackPassiveUpper:
              this.managerClassificationSettings.feedbackReply.passive,
          }
        );
        this.setValueManagerClassificationSettings();
        this.discardedSettingStatus = false;
        this.settingsStatus = !this.settingsStatus;
        setTimeout(() => {
          this.createChart();
        }, 300);
      }
    },
    addSpace(arr) {
      let text = arr.split(",");
      return text.join(", ");
    },
    countArr(arr) {
      let text = arr.split(",");
      return text.length;
    },
    sortBy(type) {
      this.selectStatus = type;
      this.$store.dispatch("insightsManagers/setStatusSorting", type);
    },
    async exportTable() {
      this.$store.dispatch("insightsManagers/getDataExport");
    },
    modalCoachingClick(email) {
      this.$store.dispatch("insightsManagers/resetState");
      this.$store.dispatch("insightsManagers/getDataCoaching", email);
      this.coachingModalStatus = !this.coachingModalStatus;
      this.modalPreviewDataStatus = false;
    },
    getPointRadius() {
      let radiusArr = [];
      for (const manager in this.datalistSearchAll) {
        let minnimaxRadius = 4,
          maxRadius = 14;
        let directReport = this.datalistSearchAll[manager].directReport;
        let redius = Math.trunc(directReport / 5 + (minnimaxRadius - 1));
        if (redius < minnimaxRadius) {
          radiusArr.push(minnimaxRadius);
        } else if (redius > maxRadius) {
          radiusArr.push(maxRadius);
        } else {
          radiusArr.push(redius);
        }
      }
      return radiusArr;
    },
    getPointColor() {
      let colorArr = [];
      for (const manager in this.datalistSearchAll) {
        if (this.datalistSearchAll[manager].activity_type == "Active") {
          colorArr.push("#66bb6a");
        } else if (this.datalistSearchAll[manager].activity_type == "Passive") {
          colorArr.push("#fbc02d");
        } else {
          colorArr.push("#f44336");
        }
      }
      return colorArr;
    },
    createChart() {

      var managerChart = this.$refs.managerChart;
      // console.log(managerChart ? "managerChart(yes)" : "managerChart(no)");
      if (!managerChart) {
        // console.log("managerCanvas was not found.");
        setTimeout(() => {
          // console.log("managerCanvas is called again");
          this.createChart();
        }, 1000);
        return;
      }

      let data = [...this.datalistSearchAll];
      let pointRadius = [...this.getPointRadius()];
      let pointColor = [...this.getPointColor()];
      if (managerChart) {
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.layout = {
          padding: {
            top: 10,
          },
          autoPadding: false,
        };
        options.scales = {
          y: {
            beginAtZero: true,
            ticks: {
              display: true,
              stepSize: 100,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
            weight: 10,
          },
          x: {
            beginAtZero: true,
            ticks: {
              display: true,
              stepSize: 10,
              callback: function (value) {
                return value + "%";
              },
            },
            grid: {
              display: false,
            },
          },
        };
        options.interaction = {
          mode: "nearest",
          intersect: false,
        };
        const getOrCreateTooltip = (chart) => {
          let tooltipEl = chart.canvas.parentNode.querySelector("div");

          if (!tooltipEl) {
            tooltipEl = document.createElement("div");
            tooltipEl.style.background = "rgba(0, 0, 0, 0.7)";
            tooltipEl.style.borderRadius = "3px";
            tooltipEl.style.color = "white";
            tooltipEl.style.opacity = 1;
            tooltipEl.style.pointerEvents = "none";
            tooltipEl.style.position = "absolute";
            tooltipEl.style.transform = "translate(-50%, 0)";
            tooltipEl.style.transition = "all .1s ease";

            const table = document.createElement("table");
            table.style.margin = "0px";

            tooltipEl.appendChild(table);
            chart.canvas.parentNode.appendChild(tooltipEl);
          }

          return tooltipEl;
        };

        const externalTooltipHandler = (context) => {
          // Tooltip Element
          const { chart, tooltip } = context;
          const tooltipEl = getOrCreateTooltip(chart);

          // Hide if no tooltip
          if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }

          // Set Text
          if (tooltip.body) {
            // const titleLines = tooltip.title || [];
            const bodyLines = tooltip.body.map((b) => b.lines);

            const tableHead = document.createElement("thead");

            const tableBody = document.createElement("tbody");

            let toolClass = 'container-tooltip';
            if ( this.blurMode ) {
              toolClass = 'blurelement';
            }

            bodyLines.forEach((body, i) => {
              const index = tooltip.dataPoints[i].dataIndex;
              const node = tooltip.dataPoints[i].dataset.data[index];
              let imagProfile = `<div style="height: 32px; width: 32px; margin: 0px 3px; display: flex; justify-content: center; align-items: center; background-color: #5f5f5f; border-radius: 32px;">
                ${node.shortname}
              </div>`;
              if (node.profilepic) {
                imagProfile = `<div style="height: 32px; width: 32px; margin: 0px 3px; display: flex; justify-content: center; align-items: center;">
                  <img src="${node.profilepic}" style="width: 32px; height: 32px; border-radius: 32px; margin-right: 2px;" />
                </div>`;
              }

              const span = `<div class="${toolClass}" style="z-index: 99">
                  <div style="display: flex; position: relative; color: #fff; width: 174px; height: 32px;">
                    <div style="margin-left: 0px;">
                      ${imagProfile}
                    </div>
                    <div style="display: flex; align-items: center; width: 90px; margin-left: 2px">
                      <div style="">
                        <div style="font-size: 11px; font-weight: 700; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 90px;">${node.fullname}</div>
                        <div style="font-size: 11px; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; width: 90px;">${node.team_name}</div>
                      </div>
                    </div>
                    <div style="display: flex; justify-content: center; align-items: center; margin: auto;">
                      <img src="${imageTooltip}" style="width:16px; height:16px; margin-right: 2px;" />
                      <div style="margin-top: 2px;">${node.directReport}</div>
                    </div>
                    <div style="position: absolute; bottom: -17.5px; left: 48%;">
                      <div style="border: 5px solid #000; border-color: #000000ae transparent transparent; width: 0px; height: 0px;"></div>
                    </div>
                  </div>
                </div>`;
              tableBody.innerHTML = span;
            });

            const tableRoot = tooltipEl.querySelector("table");

            // Remove old children
            while (tableRoot.firstChild) {
              tableRoot.firstChild.remove();
            }

            // Add new children
            tableRoot.appendChild(tableHead);
            tableRoot.appendChild(tableBody);
          }

          const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

          tooltipEl.style.opacity = 1;
          tooltipEl.style.left = positionX + tooltip.caretX + "px";
          tooltipEl.style.top = positionY + tooltip.caretY + -56 + "px";
          tooltipEl.style.font = tooltip.options.bodyFont.string;
          tooltipEl.style.padding =
            tooltip.options.padding + "px " + tooltip.options.padding + "px";
        };
        options.plugins.tooltip = {
          enabled: false,
          position: "average",
          intersect: true,
          external: externalTooltipHandler,
        };
        // data.push({
        //   active: "N",
        //   activity_type: "Inactive",
        //   critical_area: "",
        //   critical_count: "",
        //   daily: 0,
        //   directReport: 0,
        //   email: "",
        //   feedback: 0,
        //   feedback_check: "N",
        //   firstname: "-",
        //   fullname: "-",
        //   inactive: "Y",
        //   insights_opened_check: "Y",
        //   lastname: "-",
        //   network_type: "Super Outer",
        //   passive: "N",
        //   profilepic: "",
        //   score: 0,
        //   shortname: "-",
        //   standard: [],
        //   length: 3,
        //   status: "inactive",
        //   super_feedback: 0,
        //   talent: "",
        //   team_id: "",
        //   team_name: "",
        //   weekly: 0,
        //   x: 100,
        //   y: 100,
        // });
        pointColor.push("transparent");
        pointRadius.push(0);
        this.myChart = new Chart(managerChart, {
          type: "bubble",
          data: {
            datasets: [
              {
                label: "",
                data: data,
                backgroundColor: pointColor,
                pointHoverRadius: pointRadius,
                radius: pointRadius,
                pointBorderWidth: 2,
              },
            ],
          },
          options: options,
        });
      }
    },
    createChartQuality() {
      var QualityChart = this.$refs.QualityChart;
      if (QualityChart) {
        this.myChart1 = new Chart(QualityChart, {
          type: "line",
          data: {
            labels: this.label,//['Nov W1', 'Nov W2', 'Nov W3', 'Nov W4', 'Oct W1', 'Oct W2', 'Oct W3','Oct W4'],
            datasets: [
              {
                label: "Quality Score",
                data: this.weeklyData,//[65, 59, 80, 81, 56, 55, 40, 50],
                fill: false,
                borderColor: 'rgba(0, 0, 0, 0.1)',
                pointBorderColor: function (context) {
                  var index = context.dataIndex;
                  var value = context.dataset.data[index];
                  return value < 50 ? '#F44336' : value < 80 ? '#FBC02D' : '#66BB6A';
                },
                backgroundColor: 'white',
                tension: 0.1,
                borderWidth: 2,
                pointRadius: 4,
                pointBorderWidth: 3,
                pointHoverRadius: 8,
                pointHoverBorderWidth: 4,
              },
            ],
          },
          options: {
            plugins: {
              legend: {
                display: false
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'weekly averages',
                  font: {
                    family: 'Lato',
                    size: 11,
                    style: 'bold',
                    weight: 'bold',
                    lineHeight: 1.2,
                  },
                  color: 'rgba(0,0,0,0.70)'
                },
                grid: {
                  borderDash: [5, 5],
                  tickLength: 0
                },
                ticks: {
                  display: false
                }
              },
              y: {
                grid: {
                  display: false
                },
                display: false
              }
            }
          }
        });
      }
    },
    criticalAreadsCutOff(label) {
      let text = label.split(",");
      if (text.length < 2) {
        return label;
      } else if (text.length == 2) {
        return text.join(", ");
      } else {
        return `${text[1]}, ${text[2]} +${text.length - 2}`;
      }
    },
    routerLink(path, tab, query) {
      if (query) {
        this.$router.push({
          name: path,
          params: { tab: tab },
          query: { questionID: query },
        });
        this.$store.commit("dashboard/setOpenModalDashboard", true);
      } else {
        this.$router.push({ name: path, params: { tab: tab } });
      }
    },
    anchorTableLink() {
      var element = document.getElementById("scorecard");
      if (element) {
        const top = element.offsetTop;
        window.scrollTo(0, top + 130);
        this.$refs.table_anchor.scrollTop = 0 + 130;
      }
    },
    benchmarkBar(value) {
      return ((value * 120) / 100).toFixed();
    },
    arrayToPercentage(value) {
      const arr = [];
      let color = "bar-red";
      if (value > 70) {
        color = "bar-green";
      } else if (value > 40) {
        color = "bar-yellow";
      }
      for (let i = 0; i < 10; i++) {
        let status = (value - i * 10) * 1;
        let style = "";
        if (status > 10) {
          style = "";
        } else if (value - i * 10 > 0) {
          style = `opa-0${status * 1}`;
        } else {
          color = "";
        }
        arr.push(`${style} ${color}`);
      }
      return arr;
    },
    showPreviewData(row, column, event) {
      const item = row;
      this.userDetail = {};
      if (item.introduce) this.userDetail.introduce = item.introduce;
      if (item.culture_add_percentile) this.userDetail.culture_add_percentile = item.culture_add_percentile
      this.userDetail.large_pic = item.large_pic;
      this.userDetail.firstname = item.firstname;
      this.userDetail.lastname = item.lastname;
      this.userDetail.email = item.email;
      this.userDetail.dispteam = item.team_name;
      let colorCode = item.team_color ? item.team_color.replace(/#/g, "") : "";
      this.userDetail.team_color = colorCode;
      this.userDetail.team = item.team;
      this.userDetail.boss = item.boss;
      this.userDetail.tmp_boss = item.boss;
      this.userDetail.boss_pic = item.boss_pic;
      this.userDetail.dispboss = item.boss_name;
      this.userDetail.boss_firstname = item.boss_firstname;
      this.userDetail.boss_lastname = item.boss_lastname;
      this.userDetail.language = item.language;
      this.userDetail.user_type = item.user_type;
      this.userDetail.status = item.statusActive;
      this.userDetail.to_now = item.to_now;
      this.userDetail.streak_count = item.streak_count ? item.streak_count : 0;
      this.userDetail.super_feedback_count = item.super_feedback_count
        ? item.super_feedback_count
        : 0;
      this.userDetail.medal = item.medal ? item.medal : [];
      this.userDetail.coin = item.coin;
      this.userDetail.gem = item.gem;
      this.userDetail.house = item.house;
      this.userDetail.joined = item.joined ? item.joined : "";
      this.userDetail.joined_tooltips =
        item.joined_tooltips && item.joined_tooltips.length > 0
          ? item.joined_tooltips[0]
          : [];
      if (item.order_join) {
        let joinTotal = Object.keys(this.membersall).filter(
          (k) => this.membersall[k].order_join
        ).length;
        this.userDetail.joined_tooltips["percent"] = (
          ((joinTotal - item.order_join) / joinTotal) *
          100
        ).toFixed();
      }
      if (!this.coachingModalStatus) {
        this.$store.dispatch("people/getModalMemberData", item);
        this.modalPreviewDataStatus = true;
      }
    },
    closedModal() {
      this.$store.commit("people/setModalMemberData", []);
      this.modalPreviewDataStatus = !this.modalPreviewDataStatus;
    },
    getStrokeColor(value) {
      if (value >= 80) {
        return "#66BB6A";
      } else if (value >= 51 && value <= 79) {
        return "#FBC02D";
      } else if (value == '-') {
        return ''
      } else {
        return "#F44336";
      }
    },
    getStrokeDashOffset(value) {
      const totalCircumference = 62.83;
      const offset = totalCircumference * (1 - value / 100);
      return offset;
    },

    getReplyQuality(team_id) {
      if (this.dataQualitybyTeam[team_id]) {
        return this.dataQualitybyTeam[team_id].replyQuality;
      }
      return '0';
    },
    getBoxstyle(type, val) {

      if (type == 'Conversations') {
        if (val >= 60) {
          return 'box-green'
        } else if (val >= 50 && val < 60) {
          return 'box-yellow'
        } else {

          return 'box-red'
        }
      } else if (type == 'Peer-Feedback') {
        if (val >= 1) {
          return 'box-green'
        } else {
          return 'box-red'
        }
      } else if (type == 'Reviews-completed') {
        if (val >= 75) {
          return 'box-green'
        } else if (val >= 50 && val < 75) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'Goals-Progress') {
        if (val >= 75) {
          return 'box-green'
        } else if (val >= 50 && val < 75) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'Culture-Contribution') {
        if (val >= 75) {
          return 'box-green'
        } else if (val >= 50 && val < 75) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'DEBI') {
        if (val >= 70) {
          return 'box-green'
        } else if (val >= 40 && val < 70) {
          return 'box-yellow'
        } else {
          return 'box-red'
        }
      } else if (type == 'Reply-Rate') {
        //if (this.standards_data.status) {
          if (this.standards_data.feedback_rate.active == 0 && this.standards_data.feedback_rate.passive == 0) {
          return 'box-gray'
          } else if (val >= this.standards_data.feedback_rate.active) {
            return 'box-green'
          } else if (val >= this.standards_data.feedback_rate.passive && val < this.standards_data.feedback_rate.active) {
            return 'box-yellow'
          } else {
            return 'box-red'
          }
        // } else {
        //   return 'box-gray'
        // }
      } else if (type == 'Opened') {
        //if (this.standards_data.status) {
          if (this.standards_data.open_rate.active == 0 && this.standards_data.open_rate.passive == 0) {
            return 'box-gray'
          }
          else if (val >= this.standards_data.open_rate.active) {
            return 'box-green'
          } else if (val >= this.standards_data.open_rate.passive && val < this.standards_data.open_rate.active) {
            return 'box-yellow'
          } else {
            return 'box-red'
          }
        // } else {
        //   return 'box-gray'
        // }

      }
    },
    getActionItemTooltip(criticalArea) {
      const tooltips = {
        "Recognition": "Recent weekly feedback indicates low recognition levels. Consider acknowledging direct reports' efforts more frequently.",
        "Satisfaction": "Monthly responses suggest work challenge levels are suboptimal for some direct reports. Reassess individual workloads and adjust task complexity as needed.",
        "Rel. Manager": "Weekly feedback indicates limited meaningful interactions with direct reports. Increase frequency of one-on-ones or individual check-ins.",
        "Company Alignment": "This month's feedback shows direct reports' performance towards company goals needs improvement. Clarify objectives and provide more personalized guidance.",
        "Happiness": "Daily pulse checks indicate low morale among direct reports. Investigate immediate causes and implement targeted mood-boosting initiatives.",
        "Ambassadorship": "This month's responses suggest the company isn't meeting direct reports' expectations. Address individual concerns and improve communication.",
        "Wellness": "Weekly surveys show high stress levels among direct reports. Monitor individual workload distribution and actively promote work-life balance.",
        "Feedback": "Weekly responses indicate direct reports desire more feedback. Increase frequency and quality of individual performance discussions.",
        "Personal Growth": "Monthly feedback suggests direct reports feel their growth is stagnating. Identify personalized skill development opportunities and create individual learning plans.",
        "Rel. Colleagues": "Monthly feedback indicates issues with peer support among direct reports. Encourage team collaboration and address any interpersonal challenges."
      };

      if (!criticalArea) return "No action items identified.";

      const areas = criticalArea.split(', ');
      const tooltipContent = areas.map(area => tooltips[area] || `Address issues related to ${area}.`).join('\n\n');

      return tooltipContent || "Address the identified action items.";
    },
    getReviewCompleted(){
      const datalist=this.datalistSearchAll
      let memberbyteam=this.memberbyteam
      let dataQualitybyTeam=0
      let count=0
      //console.log('performance_review[i].completed',this.selectTeam)

      if(this.selectTeam=='all'||this.selectTeam==this.teamHeight){
        memberbyteam=Object.keys(this.membersall).length
        if(this.user_placeholder&&this.user_placeholder.completed){
          //console.log('this.user_placeholder',this.user_placeholder)
          dataQualitybyTeam=dataQualitybyTeam+this.user_placeholder.completed
        }

      }
      
      
      for(let key in datalist){
        const val=datalist[key]
        if(this.dataQualitybyTeam[val.email] && this.dataQualitybyTeam[val.email].performance_review.completed){
         
          dataQualitybyTeam=dataQualitybyTeam+Number(this.dataQualitybyTeam[val.email].performance_review.completed)
          
         
          
          
          
        }
          
      }
      
   
      
      return isNaN(dataQualitybyTeam/memberbyteam)?0:(dataQualitybyTeam/memberbyteam).toFixed()
    }
  },
};
</script>

<style lang="scss" scoped>
.small-active-card {
  width: 100px;
  height: 85px;
  border-radius: 6px;
  text-align: center;
  box-sizing: border-box;
  background-color: #f4f4f4;
  margin-right: 6px;
}

.active-card {
  width: 185px;
  height: 85px;
  border-radius: 6px;
  text-align: center;
  box-sizing: border-box;
  background-color: #f4f4f4;
}

.txt-percent {
  color: #363636;
  margin-left: 6px;
  font-size: 14px;
}

.txt-percent.green {
  color: #27bc6c;
}

.txt-percent.yellow {
  color: #fbc02d;
}

.txt-percent.red {
  color: #f44336;
}

.txt-detail-percent {
  font-size: 11px;
  opacity: 0.5;
  color: #000;
}

.txt-head-card {
  font-size: 28px;
  display: inline-block;
}

.top-title {
  text-align: center;
  margin-bottom: -9px;
  z-index: 10;
  font-weight: 700;

  >div {
    padding: 4px;
    background-color: rgba(#000, 0.02);
    border-radius: 3px;
    margin: 0 8px;
    font-size: 12px;
    color: #454545;
  }
}

.txtDataList {
  font-size: 12px;
  color: #3c3c3c;
}

.text-modal {
  font-size: 13px;
  color: #4a4a4a;
}

.txtName,
.txtTeam {
  color: #3c3c3c;
  width: 160px;
}

.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}

.txtOption1 {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  height: 40px;
  display: inline-block;
}

.menu-option-style {
  border-bottom: transparent;
  background: #f4f4f4;
  border-radius: 4px;
}

.chart-container {
  position: relative;
  height: 190px;
  margin-top: 16px;
  padding: 16px 16px 32px 32px;
  background-color: #00000002;
}

.site-text {
  transform: rotate(-90deg);
  width: 120px;
  position: absolute;
  margin-top: 113px;
  margin-left: -32px;
}

.imgProfile {
  width: 36px;
  height: 36px;
  border-radius: 36px;
}

.profilepic {
  position: relative
}

.profilepic .noti-count {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  background-color: #685D79;
  color: white;
  font-family: 'Lato';
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
}

.activity-status {
  font-size: 11px;
  font-weight: 700;
  border-radius: 4px;
  padding: 1px 4px 0;
}

.activity-status.active {
  color: #43500d;
  background-color: rgba(#66bb6a, 0.15);
}

.activity-status.passive {
  color: #745301;
  background-color: rgba(#fbc02d, 0.15);
}

.activity-status.in-Active {
  color: #6e1d17;
  background-color: rgba(#f44336, 0.15);
}

.span-last-30-day {
  border-radius: 2px;
  background-color: rgba(#000, 0.06);
  color: #6c30cc;
  font-size: 11px;
  font-weight: 700;
  padding: 8px 12px;
  margin: 0 0 0 14px;
}

.report-container {
  display: grid;
  grid-template-columns: 416px 256px auto;

  .text-header {
    font-size: 15px;
    font-weight: 700;
  }

  .text-green {
    color: #1ac362;
  }

  .text-red {
    color: #f44336;
  }

  .title {
    font-size: 12px;
    font-weight: 700;
    color: #000;
  }

  .box-card-border {
    box-shadow:
      0px 0.3px 0.9px rgba(0, 0, 0, 0.008),
      0px 0.8px 2.1px rgba(0, 0, 0, 0.012),
      0px 1.5px 4px rgba(0, 0, 0, 0.015),
      0px 2.7px 7.1px rgba(0, 0, 0, 0.018),
      0px 5px 13.4px rgba(0, 0, 0, 0.022),
      0px 12px 32px rgba(0, 0, 0, 0.03);
    border-radius: 4px;
    padding: 24px 16px 16px;
    margin-top: 8px;
    min-height: calc(169px - 40px);
  }

  .box-card-border1 {
    box-shadow: 0px 2px 4px #00000029;
    border-radius: 4px;
    padding: 21px 16px 16px;
    margin-top: 8px;
    min-height: calc(169px - 40px);
  }

  .grid-3-auto {
    display: grid;
    grid-template-columns: repeat(3, calc((100% / 3) - ((24px * 2) / 3)));
    gap: 24px;

    .status-box {
      border-radius: 4px;
      height: calc(69px - 16px);
      padding: 8px 12px;

      .circle {
        width: 24px;
        height: 24px;
        border-radius: 24px;
        object-fit: cover;
      }
    }
  }

  .label-change {
    font-size: 11px;
    font-weight: 700;
    margin-top: 4px;
    margin-left: 3px;
    width: 44px;
    white-space: nowrap;
  }

  .bar-contariner {
    .bar {
      border-radius: 6px;
      width: 6px;
      height: 32px;
      margin-right: 2px;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }

    .bar-green {
      background-color: #35d077;
    }

    .bar-yellow {
      background-color: #fbc02d;
    }

    .bar-red {
      background-color: #f44336;
    }
  }

  .benchmark {
    width: 46px;
    text-align: center;
    padding: 10px 0 8px;
    font-size: 16px;
    font-weight: 700;
    color: #fff;
    border-radius: 4px;
    margin-right: 16px;
    background-color: #e0e0e0;
  }

  .benchmark.green {
    background-color: #35d077;
  }

  .benchmark.red {
    background-color: #f44336;
  }

  .benchmark.yellow {
    background-color: #fbc02d;
  }

  .point-bar {
    width: 150px;
    border-radius: 6px;
    height: 6px;
    background-color: rgba($color: #000000, $alpha: 0.2);

    .value {
      position: relative;
      border-radius: 6px;
      height: 6px;
      background: #35d077;
    }

    .value.benchmark {
      position: relative;
      height: 6px;
      top: -6px;
      background: transparent;

      &::before {
        content: "";
        position: absolute;
        right: -1px;
        top: -3px;
        border-right: 2px solid #6c30cc;
        height: 12px;
      }
    }
  }

  .gray-icon-32 {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background-color: #b4b4b4;
    object-fit: cover;
  }

  .score-box {
    width: 38px;
    height: 32px;
    text-align: center;
    font-size: 14px;
    font-weight: 900;
    color: #fff;
    border-radius: 5px;
    margin-right: 12px;
    background-color: #e0e0e0;
  }

  .score-box.yellow {
    background-color: #fbc02d;
  }

  .score-box.green {
    background-color: #35d077;
  }

  .score-box.red {
    background-color: #f44336;
  }
}

.divTable .status {
  width: 16px;
  height: 16px;
  margin-bottom: 3px;
  vertical-align: middle;
}

.divTable .progress-wrapper {
  position: relative;
  width: 26px;
  height: 26px;
  display: inline-block;
  vertical-align: middle;
}

.divTable .score-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 500;
  color: #000;
  text-align: center;
  z-index: 2;
  text-align: center;
  line-height: 24px;
  /* Adjust this if you change the .progress-wrapper dimensions */
  white-space: nowrap;
  /* Prevents the label from wrapping to the next line */
}

.box-card-border .score-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  font-weight: 500;
  color: #000;
  text-align: center;
  z-index: 2;
  text-align: center;
  line-height: 24px;
  /* Adjust this if you change the .progress-wrapper dimensions */
  white-space: nowrap;
  /* Prevents the label from wrapping to the next line */
}

.score-label .main {
  font-size: 42px;
  line-height: 42px;
}

.score-label .description {
  line-height: 18px;
}

.box-card-border .progress-wrapper {
  position: relative;
  width: 135px;
  height: 135px;
  display: inline-block;
  vertical-align: middle;
}

.box-card-table {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000001F;
  border-radius: 6px;
  opacity: 1;
  min-height: 53px;
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.box {
  border-radius: 6px;

  top: 1326px;
  left: 546px;
  width: 36px;
  height: 28px;
  margin-left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000000;
}

.box-red {
  background: #fdd9d7 0% 0% no-repeat padding-box;

}

.box-yellow {
  background: #fef2d5 0% 0% no-repeat padding-box;

}

.box-green {
  background: #e0f1e1 0% 0% no-repeat padding-box;

}

.box-gray {
  background: #e7e7e7 0% 0% no-repeat padding-box;

}

.line-break {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-000000);
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #000000;
  opacity: 0.1;
}
</style>

<style lang="scss">
#insightsManagers2 .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f5f580;
  cursor: pointer;

  .buttom-detail-image {
    opacity: 1;
  }
}

#menuDropdown .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}

#menuDropdownType .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}

#coachingModalStatus {
  .el-dialog__header {
    padding-top: 32px;
    padding-left: 40px;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }
  }

  .el-dialog__body {
    padding: 0;

    .profile {
      padding: 12px 40px 16px;
      height: 45px;
    }

    .table {
      padding: 12px 12px 24px 40px;
      box-shadow: inset 0px 5px 3px 0px #0000001c;

      .score {
        width: 60px;
        margin: auto;
        padding-left: 4px;
      }

      .circle-score {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        margin-top: 6px;
        margin-right: 4px;
      }

      .circle-red {
        background-color: #f44336;
      }

      .circle-green {
        background-color: #66bb6a;
      }

      .circle-yellow {
        background-color: #fbc02d;
      }
    }
  }
}

#managerClassificationSettingsModalStatus {
  .el-dialog__header {
    padding-top: 32px;
    padding-left: 40px;

    .el-dialog__title {
      font-size: 20px;
      font-weight: 700;
      color: #000;
    }
  }

  .el-dialog__body {
    padding: 22px 40px 40px;

    .input-size {
      width: 74px;
      position: relative;
    }

    .title-text-input {
      font-size: 16px;
      color: #000;
      margin-right: 12px;
    }

    .percentag-text {
      position: absolute;
      top: 11px;
      right: 12px;
      font-weight: 700;
      color: #4a4a4a;
    }

    .percentag-text.disabled {
      opacity: 0.5;
    }
  }
}

#insightsManagerTable {
  .labelTableStyle.is-leaf {
    font-size: 12px;
    font-weight: 500;
  }

  .labelTableStyle.is-leaf {
    padding-left: 0;
    padding-right: 0;
  }

  .labelTableStyle.SortStyle {
    padding-left: 0;
    padding-right: 0;
  }

  .labelTableStyle {
    font-size: 12px;
  }

  .el-table__header {
    border: 1px solid #e0e0e0;
    border-width: 0 0 1px 0;

    th {
      padding-bottom: 6px;
    }
  }

  td {
    // padding-bottom: 0px;
  }

}

#insightsManagerTable.el-table .el-table__cell {
  padding: 6px 0 !important;
}

#insightsManagerTable .el-table__body-wrapper {
  padding-top: 12px;
}

#insightsManagers2 {
  .el-table .cell {
    padding: 0 5px;
  }
}

.section-break {
  height: 20px;
  width: 1px;
  background-color: rgba(#000, 0.1);
  align-items: center;
  justify-content: center;
  margin-top: 4px;
}
</style>
